/**
 *
 * @param {{children:string, variant:'main' | "secondary"}} param0
 * @returns
 */
export default function StatusTag({ children, variant }) {
  const colors = {
    main: 'bg-green-500 text-white',
    secondary: 'bg-segments-gray text-black text-opacity-30 ',
  };

  return (
    <p
      className={`px-segments-10px rounded-2xl capitalize text-sm py-0.5 ${colors[variant]}`}
    >
      {children}
    </p>
  );
}
